import { memoize } from 'proxy-memoize';
import { useMemo, type DependencyList } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '/business/shared/state/store';

const useSelectorMemoized = <Selected>(callback: (state: RootState) => Selected, deps?: DependencyList): Selected => {
  const selectorLoad = useMemo(() => memoize(callback), deps || []);
  return useSelector(selectorLoad);
};

export default useSelectorMemoized;
